import { Icon, type IconName } from '@/components';
import { cn } from '@/lib/cn';
import { A } from '@solidjs/router';
import { type JSX, Show } from 'solid-js';

const ACTIVE_CLASS = 'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-200';
const INACTIVE_CLASS =
  'text-neutral-600 hover:bg-neutral-100 hover:text-neutral-900 dark:text-neutral-300 dark:hover:bg-neutral-800 dark:hover:text-neutral-100';

interface Props {
  href: string;
  icon: IconName;
  label: string;
  collapsed: boolean;
  onClick?: () => void;
  /** Exact-path matching (router `end`); default keeps legacy prefix matching. */
  end?: boolean;
  /** Overrides the router's active detection entirely when provided. */
  active?: boolean;
}

export const NavItem = (props: Props): JSX.Element => (
  <A
    href={props.href}
    onClick={props.onClick}
    {...(props.active === undefined
      ? { activeClass: ACTIVE_CLASS, inactiveClass: INACTIVE_CLASS, end: props.end ?? false }
      : {})}
    class={cn(
      'group relative flex items-center gap-3 overflow-hidden rounded-lg px-3 py-2 text-sm font-medium transition-colors',
      props.active === true && ACTIVE_CLASS,
      props.active === false && INACTIVE_CLASS,
    )}
    title={props.collapsed ? props.label : undefined}
  >
    <Icon name={props.icon} class="shrink-0" />
    <Show when={!props.collapsed}>
      <span class="whitespace-nowrap">{props.label}</span>
    </Show>
  </A>
);
